"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.STATE = void 0;
var _react = require("react");
var _DOMutils = require("./DOMutils");
const STATE = exports.STATE = {
  IS_CLOSE: 0,
  IS_IN_PROGRESS: 1,
  IS_OPEN: 2
};
const isWindowReady = typeof window !== 'undefined';
const noop = () => {};
var _default = exports.default = function _default() {
  let hookOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const placeholderRef = hookOptions.placeholderRef ? hookOptions.placeholderRef : (0, _react.useRef)(null);
  const activeTriggerRef = (0, _react.useRef)({
    nodeRef: null,
    options: null
  });
  const [activeModal, setActiveModal] = (0, _react.useState)(null);
  const [state, setState] = (0, _react.useState)(STATE.IS_CLOSE);
  const onOpenCallback = hookOptions.onOpen || noop;
  const onCloseCallback = hookOptions.onClose || noop;
  const open = (triggerRef, triggerOptions) => {
    activeTriggerRef.current.nodeRef = triggerRef;
    if (placeholderRef.current && triggerRef.current) {
      const placeholder = placeholderRef.current;
      const trigger = triggerRef.current;
      const triggerStyles = isWindowReady && trigger.ownerDocument ? window.getComputedStyle(trigger) : trigger;
      const borderRadius = (0, _DOMutils.getBorderRadius)(triggerStyles);
      let modalId = null;
      let background = hookOptions.background || (0, _DOMutils.getBackground)(triggerStyles);
      let onOpen = onOpenCallback;
      if (typeof triggerOptions === 'number' || typeof triggerOptions === 'string' || typeof triggerOptions === 'symbol') {
        modalId = triggerOptions;
      } else if (typeof triggerOptions === 'object' && triggerOptions !== null) {
        activeTriggerRef.current.options = triggerOptions;
        modalId = triggerOptions.id || modalId;
        background = triggerOptions.background || background;
        onOpen = triggerOptions.onOpen || onOpenCallback;
      }
      _DOMutils.bodyScrolling.lock();
      placeholder.style.cssText = "width: ".concat(trigger.offsetWidth, "px; height: ").concat(trigger.offsetHeight, "px; background: ").concat(background, "; ").concat(borderRadius);
      if (modalId) {
        setActiveModal(modalId);
      }
      setState(STATE.IS_IN_PROGRESS);
      const placeholderStyle = (0, _DOMutils.getPlaceholderComputedStyle)(trigger, placeholder);
      placeholder.style.cssText += placeholderStyle;
      placeholder.addEventListener('transitionend', () => {
        onOpen();
        setState(STATE.IS_OPEN);
      }, {
        once: true
      });
    }
  };
  const close = () => {
    if (placeholderRef.current) {
      const triggerOptions = activeTriggerRef.current.options;
      const placeholder = placeholderRef.current;
      const onClose = triggerOptions && triggerOptions.onClose ? triggerOptions.onClose : onCloseCallback;
      setState(STATE.IS_IN_PROGRESS);
      _DOMutils.bodyScrolling.unlock();
      placeholder.style.removeProperty('transform');
      placeholder.style.transform = 'scale(1,1);';
      placeholder.addEventListener('transitionend', () => {
        onClose();
        setState(STATE.IS_CLOSE);
        setActiveModal(null);
      }, {
        once: true
      });
    }
  };
  return {
    open,
    close,
    activeModal,
    modalProps: {
      placeholderRef,
      state,
      close
    }
  };
};